import React, { useState } from "react";
import UAFeedContent from "../Utils/Feed/UAFeedContent";
import FeedFilterDropdown from "../Utils/FeedFilterDown";
import "../Styles/UserAccountGridLayout.css";
import UserAccountShowAllPost from "../Utils/Post/UAPostContent";
import UASharedContent from "../Utils/Shared/UASharedContent";
import UASuggestedContent from "../Utils/Suggest/UASuggestContent";
import UASavedContent from "../Utils/Saved/UASavedContent";
import UAArchiveContent from "../Utils/Archive/UAArchiveContent";
import UserAccountCreatePost from "../Utils/Post/UserAccountCreatePost";
import CreatorSpaceSection from "../Utils/CreatorSpaceSection";
import { left } from "@popperjs/core";

// Parent Layout Component
const UserFeedCenterLayout = ({
  mediaDisplayMode,
  userId,
  profileId,
  activeFilter,
  setActiveFilter,
}) => {
  return (
    <div
      className="uac-feed-wrapper"
      style={{ display: "flex", flexDirection: "column" }}
    >
      {/* Filter Dropdown */}
      <div className="uac-feed-filter-section" style={{ marginLeft: 0, width: "100%", display: "flex", justifyContent: "center" }}>
        <div style={{ width: "100%", height: 70 }}>
        <FeedFilterDropdown activeTab={activeFilter} setActiveTab={setActiveFilter} />
        </div>
      </div>

      {/* Create Post Panel (only when post filter active) */}
      <div style={{ marginTop: -30, width: "100%", alignSelf: "center" }}>
        {activeFilter === "post" && (
          <UserAccountCreatePost userid={userId} profileid={profileId} />
        )}
      </div>

      {/* Creator Space — shown only on feed tab, before content */}
      {activeFilter === "feed" && (
        <div style={{ marginTop: 16, width: "100%" }}>
          <CreatorSpaceSection />
        </div>
      )}

      {/* Main Feed Content */}
      <div
        className="uac-main-feed-container"
        style={{ marginTop: 16, marginBottom: 50 }}
      >
        {activeFilter === "feed" && (
          <UAFeedContent
            mediaDisplayMode={mediaDisplayMode}
            liUserId={userId}
            activeFilter={activeFilter}
            setActiveFilter={setActiveFilter}
          />
        )}
        {activeFilter === "post" && (
          <UserAccountShowAllPost
            mediaDisplayMode={mediaDisplayMode}
            userid={userId}
            profileid={profileId}
            activeFilter={activeFilter}
            setActiveFilter={setActiveFilter}
          />
        )}
        {activeFilter === "shared" && (
          <UASharedContent
            mediaDisplayMode={mediaDisplayMode}
            activeFilter={activeFilter}
            setActiveFilter={setActiveFilter}
          />
        )}
        {activeFilter === "suggested" && (
          <UASuggestedContent
            mediaDisplayMode={mediaDisplayMode}
            userId={userId}
            activeFilter={activeFilter}
            setActiveFilter={setActiveFilter}
          />
        )}
        {activeFilter === "saved" && (
          <UASavedContent
            mediaDisplayMode={mediaDisplayMode}
            activeFilter={activeFilter}
            setActiveFilter={setActiveFilter}
          />
        )}
        {activeFilter === "archive" && (
          <UAArchiveContent
            mediaDisplayMode={mediaDisplayMode}
            activeFilter={activeFilter}
            setActiveFilter={setActiveFilter}
          />
        )}
      </div>
    </div>
  );
};

export default UserFeedCenterLayout;